import { Box, IconButton, Menu, Typography } from '@mui/material';
import { SlidersHorizontal } from 'lucide-react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ResizeLayoutModifier from '~/components/Sliders/ResizeLayoutModifier';
import GlobalContourThicknessModifier from '~/components/Sliders/GlobalContourThicknessModifier';
import DoseOpacityModifier from '~/components/Sliders/DoseOpacityModifier';
import MonacoExportCheckbox from '~/components/Checkboxes/MonacoExportCheckbox';

const GlobalSettings = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const menuOpen = Boolean(anchorEl);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                aria-label="open-global-settings"
                aria-haspopup="true"
                onClick={handleOpen}
            >
                <SlidersHorizontal />
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                slotProps={{
                    paper: {
                        sx: {
                            background: 'rgba(4, 30, 52, 0.65)',
                            backdropFilter: 'blur(5px)',
                            WebkitBackdropFilter: 'blur(5px)',
                            border: '1px solid rgba(0, 0, 0, 0.1)',
                            p: 2,
                            borderRadius: 2,
                            width: 'clamp(300px, 30vw, 400px)', // responsive width for larger and smaller screens
                            minWidth: '300px',
                            color: 'white',
                            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.27)',
                        },
                    },
                }}
            >
                <Box display="flex" flexDirection="column" gap={2}>
                    <Box>
                        <Typography variant="h6">
                            <FormattedMessage id="globalSettings" />
                        </Typography>
                    </Box>
                    <ResizeLayoutModifier />
                    <GlobalContourThicknessModifier />
                    <DoseOpacityModifier />
                    <MonacoExportCheckbox />
                </Box>
            </Menu>
        </>
    );
};

export default GlobalSettings;
